import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from "@angular/common/http";
import { map, Observable, tap } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { DynamicEntityDto, DynamicPropertyDto, DynamicTemplateDto, WorkflowDto, WorkflowRoleDto } from "./dto";
import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Injectable({
	providedIn: 'root'
})
export class HttpWorkflowRoleService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/workflow_role', authService);
	}
	public getAll(): Observable<WorkflowRoleDto[]> {
		return super.doGet(true, "/");
	}
	// public newWorkflow(): Observable<WorkflowDto> {
	// 	return super.doGet(true, `/new`);
	// }
	public get(id: number): Observable<WorkflowRoleDto> {
		return super.doGet(true, `/${id}`);
	}
	public editWorkflowRole(id: number, payload: WorkflowRoleDto): Observable<WorkflowRoleDto> {
		return super.doPost(true, `/${id}`, payload);
	}
	public createWorkflowRole(workflowId: number, payload: WorkflowRoleDto | FormGroup): Observable<WorkflowRoleDto> {
		return super.doPost(true, `/workflow:${workflowId}`, payload);
	}
	// public getEmailPlaceholders(id: number|undefined, payload: WorkflowDto): Observable<any> {
	// 	if(id){
	// 		return super.doPost(true, `/${id}/emailPlaceholders`, payload);
	// 	}else{
	// 		return super.doPost(true, `/emailPlaceholders`, payload);
	// 	}

	// }
}
